// src/mechanism/appHooks.js

// 存储钩子的数组
const loginHooks = [];
const logoutHooks = [];
const appLaunchHooks = []; // ✨ App冷启动
const appCloseHooks = [];  // ✨ App杀进程
const appInForegroundHooks = []; // ✨ App 切入
const appInBackgroundHooks = [];// ✨ App 切出
const networkOnlineHooks = [];  // ✨ 网络恢复
const networkOfflineHooks = []; // ✨ 网络断开

let isAppLaunched = false;

/**
 * 🌟 暴露给业务层的注册方法
 */
export const registerLoginHook = (hook) => {
    if (typeof hook === 'function') loginHooks.push(hook);
};

export const registerLogoutHook = (hook) => {
    if (typeof hook === 'function') logoutHooks.push(hook);
};

// 注册App启动时的任务
export const registerAppLaunchHook = (hook) => {
    if (typeof hook !== 'function') return;

    if (isAppLaunched) {
        // 🔥 如果 App 已经完成了启动，直接补发执行（通过微任务异步调用，保持统一的行为模式）
        Promise.resolve().then(async () => {
            try {
                await hook();
            } catch (err) {
                console.error('[App Hooks] 补发 AppLaunchHook 执行失败:', err);
            }
        });
    } else {
        // 尚未启动，正常排队
        appLaunchHooks.push(hook);
    }
};
// 注册App杀掉进程时的任务
export const registerAppCloseHook = (hook) => {
    if (typeof hook === 'function') appCloseHooks.push(hook);
};

// 切入App时的任务
export const registerInForegroundHook = (hook) => {
    if (typeof hook === 'function') appInForegroundHooks.push(hook);
};

// 切出App时的任务
export const registerInBackgroundHook = (hook) => {
    if (typeof hook === 'function') appInBackgroundHooks.push(hook);
};

export const registerNetworkOnlineHook = (hook) => {
    if (typeof hook === 'function') networkOnlineHooks.push(hook);
};

// 注册网络断开时的任务
export const registerNetworkOfflineHook = (hook) => {
    if (typeof hook === 'function') networkOfflineHooks.push(hook);
};


/**
 * 🌟 暴露给底层的触发方法 (在 App.vue 或 main.js 中调用)
 */
export const triggerLoginHooks = async () => {
    console.log(`[Auth Hooks] 触发登录回调，当前注入了 ${loginHooks.length} 个任务`);
    await Promise.allSettled(loginHooks.map(hook => hook()));
};

export const triggerLogoutHooks = async () => {
    console.log(`[Auth Hooks] 触发登出回调，当前注入了 ${logoutHooks.length} 个清理任务`);
    await Promise.allSettled(logoutHooks.map(hook => hook()));
};

// 触发App启动
export const triggerAppLaunchHooks = async () => {
    if (isAppLaunched) {
        console.warn('[App Hooks] App 已经启动过，忽略重复触发');
        return;
    }

    // 标记启动状态已就绪
    isAppLaunched = true;

    console.log(`[App Hooks] 触发冷启动回调，当前队列共有 ${appLaunchHooks.length} 个任务`);

    // 执行已排队的任务
    await Promise.allSettled(appLaunchHooks.map(async (hook) => {
        try {
            await hook();
        } catch (err) {
            console.error('[App Hooks] AppLaunchHook 任务执行异常:', err);
        }
    }));

    // 执行完毕后清空数组，释放闭包内存
    appLaunchHooks.length = 0;
};

// 触发App关闭
export const triggerAppCloseHooks = async () => {
    console.log(`[App Hooks] 触发App关闭回调，当前注入了 ${appCloseHooks.length} 个清理任务`);
    await Promise.allSettled(appCloseHooks.map(hook => hook()));
};


export const triggerInForegroundHooks = async () => {
    console.log(`[App Hooks] 触发进入程序回调，当前注入了 ${appInForegroundHooks.length} 个任务`);
    await Promise.allSettled(appInForegroundHooks.map(hook => hook()));
};

// 触发App关闭
export const triggerInBackgroundHooks = async () => {
    console.log(`[App Hooks] 触发App切出回调，当前注入了 ${appInBackgroundHooks.length} 个清理任务`);
    await Promise.allSettled(appInBackgroundHooks.map(hook => hook()));
};


// 触发网络恢复
export const triggerNetworkOnlineHooks = async () => {
    console.log(`[App Hooks] 触发网络恢复回调，当前注入了 ${networkOnlineHooks.length} 个任务`);
    await Promise.allSettled(networkOnlineHooks.map(hook => hook()));
};

// 触发网络断开
export const triggerNetworkOfflineHooks = async () => {
    console.log(`[App Hooks] 触发网络断开回调，当前注入了 ${networkOfflineHooks.length} 个任务`);
    await Promise.allSettled(networkOfflineHooks.map(hook => hook()));
};